export type RemoteSource = 'dropbox' | 'google-drive' | 'onedrive';

/** What every picker hands back, normalised. The server does the downloading. */
export interface PickedFile {
  name: string;
  url: string;
  bytes?: number;
  /** Only for providers whose download URL is not already pre-signed. */
  bearerToken?: string;
  source: RemoteSource;
}

export const HEIC_EXTENSIONS = ['.heic', '.heif', '.HEIC', '.HEIF'];

export function isHeicName(name: string): boolean {
  return /\.(heic|heif)$/i.test(name);
}
